import React from 'react';
import AddIcon from '@mui/icons-material//Add';
import { Button } from '@mui/material';
import { AddActionButtonProps } from './AddActionButton.props';

const AddActionButton = ({ disabled, id, onClickHandler, text }: AddActionButtonProps) => (
  <div>
    <Button
      className="btn-table-aligned"
      disabled={disabled}
      id={id}
      onClick={onClickHandler}
      startIcon={<AddIcon />}
      variant="outlined">
      {text}
    </Button>
  </div>
);

export default React.memo(AddActionButton);
